<p-tree
  #treeReference
  [style]="style"
  styleClass="tree-multi card-blue light md bordered"
  [value]="nodes"
  [selectionMode]="selectionMode"
  [filter]="filterPlaceholder ? true : false"
  filterMode="strict"
  [filterPlaceholder]="filterPlaceholder | translate"
  [(selection)]="selection"
  (onNodeSelect)="rowSelected($event)"
  (onNodeUnselect)="rowUnselect($event)"
  [metaKeySelection]="false"
  [propagateSelectionDown]="propagateSelectionDown"
  [propagateSelectionUp]="propagateSelectionUp"
  (onNodeExpand)="$event.originalEvent.stopPropagation(); isExpanded = true"
  (onNodeCollapse)="$event.originalEvent.stopPropagation(); isExpanded = false"
  [dir]="dir"
  >
  <ng-template let-node pTemplate="parent">
    <div (click)="selected($event, node)" class="row no-overflow7" style="height: 48px" (keydown.enter)="selected($event, node)" tabindex="0" role="button">
      @if (!inlineEditable) {
        <div class="row-inline">
          <h4 class="no-mg">{{ node.label }}</h4>
        </div>
      }
      @if (editable && inlineEditable) {
        <div>
          <ng-container *ngTemplateOutlet="nodeRender; context: { node: node }"></ng-container>
        </div>
      }
      <div class="row-inline">
        @if (editable) {
          <div>
            <button [disabled]="!nodes.length || nodes.length === 1" type="button" (click)="onDelete($event, node)" class="btn btn-danger-link active">
              <i aria-hidden="true" class="pi pi-trash"></i>
            </button>
            <button type="button" (click)="onAdd($event, node)" class="btn btn-primary-link active"><i aria-hidden="true" class="pi pi-plus-circle"></i></button>
          </div>
        }
        @if (node?.children?.length) {
          <div class="divider-v" style="height: 15px"></div>
        }
      </div>
      @if (isChipDisplay(node)) {
        <app-chips-with-remained-data [data]="chipData(node)"></app-chips-with-remained-data>
      }
      @if (statistics) {
        <img
          [src]="'https://storage.googleapis.com/yabi-papi-storage/media/icons/gaterix-status/' + (iconFromStatistics(node) || 'error.svg')"
          width="26"
          alt=""
          class="mr-5"
          />
      }
    </div>
  </ng-template>
  <ng-template let-node pTemplate="child">
    <div (click)="selected($event, node)" class="row no-overflow" style="height: 48px" (keydown.enter)="selected($event, node)" tabindex="0" role="button">
      @if (!inlineEditable) {
        <div class="row-inline">
          <h4 class="no-mg">{{ node.label }}</h4>
        </div>
      }
      @if (editable && inlineEditable) {
        <div>
          <ng-container *ngTemplateOutlet="nodeRender; context: { node: node }"></ng-container>
        </div>
      }
      <div class="row-inline">
        @if (editable) {
          <div>
            <button type="button" (click)="onDelete($event, node)" class="btn btn-danger-link active"><i aria-hidden="true" class="pi pi-trash"></i></button>
            <button type="button" (click)="onAdd($event, node)" class="btn btn-primary-link active"><i aria-hidden="true" class="pi pi-plus-circle"></i></button>
          </div>
        }
        @if (node?.children?.length) {
          <div class="divider-v" style="height: 15px"></div>
        }
      </div>
      @if (isChipDisplay(node)) {
        <app-chips-with-remained-data [data]="chipData(node)"></app-chips-with-remained-data>
      }
      @if (statistics) {
        <img
          [src]="'https://storage.googleapis.com/yabi-papi-storage/media/icons/gaterix-status/' + (iconFromStatistics(node) || 'error.svg')"
          width="26"
          alt=""
          class="mr-5"
          />
      }
    </div>
  </ng-template>

  @if (editable && addNewNodeLabel) {
    <ng-template pTemplate="footer">
      <div class="divider-h darken mt-5 mb-5"></div>
      <button
        (click)="onAdd($event)"
        pButton
        pRipple
        type="button"
        icon="pi pi-plus-circle"
        id="add-new-gate-in-tree"
        [label]="addNewNodeLabel | translate"
        class="p-button-text mg-5 button"
      ></button>
    </ng-template>
  }
</p-tree>
